<h3 class="text-3xl md:text-4xl font-medium title-font mt-14 mb-10 text-center">Unsere Lehrer</h3>

<div class="mb-20 flex flex-wrap justify-center">
  <app-instructor-card [instructorCard]="instructorAndo"></app-instructor-card>
<!--  <app-instructor-card [instructorCard]="instructorHenrique"></app-instructor-card>-->
<!--  <app-instructor-card [instructorCard]="instructorBrunno"></app-instructor-card>-->
</div>
